import { forwardRef, type InputHTMLAttributes } from 'react'
import { cn } from '../lib/cn'

export type InputProps = InputHTMLAttributes<HTMLInputElement> & {
  invalid?: boolean
}

export const Input = forwardRef<HTMLInputElement, InputProps>(function Input(
  { invalid, className, ...rest },
  ref,
) {
  return (
    <input
      ref={ref}
      {...rest}
      className={cn(
        'h-10 w-full rounded-md border bg-white px-3 text-base outline-none transition-colors',
        'border-gray-300 focus:border-blue-500 focus:ring-2 focus:ring-blue-500/30',
        invalid && 'border-red-500 focus:border-red-500 focus:ring-red-500/30',
        className,
      )}
    />
  )
})
